var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBriefcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.88 25.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_briefcase") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.61,20.53A1.39,1.39,0,0,1,40,21.92v15a1.39,1.39,0,0,1-1.39,1.39H11.51a1.39,1.39,0,0,1-1.39-1.39v-15a1.39,1.39,0,0,1,1.39-1.39h27.1m0-2H11.51a3.39,3.39,0,0,0-3.39,3.39v15a3.39,3.39,0,0,0,3.39,3.39h27.1A3.39,3.39,0,0,0,42,36.92v-15a3.39,3.39,0,0,0-3.39-3.39Z",
    transform: "translate(-8.13 -14.46)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.41,16.46a.63.63,0,0,1,.63.63v1.42H21.09V17.09a.63.63,0,0,1,.62-.63h6.7m0-2h-6.7a2.62,2.62,0,0,0-2.62,2.63v3.42H31V17.09a2.63,2.63,0,0,0-2.63-2.63Z",
    transform: "translate(-8.13 -14.46)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.48,29.6v.84h-.84V29.6h.84m.58-2h-2A1.43,1.43,0,0,0,22.64,29v2a1.42,1.42,0,0,0,1.42,1.42h2A1.41,1.41,0,0,0,27.48,31V29a1.42,1.42,0,0,0-1.42-1.43Z",
    transform: "translate(-8.13 -14.46)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.62,20.53A1.38,1.38,0,0,1,40,21.91v5.4a82.32,82.32,0,0,1-14.94,1.32,82.4,82.4,0,0,1-14.94-1.32v-5.4a1.38,1.38,0,0,1,1.38-1.38H38.62m0-2H11.5a3.38,3.38,0,0,0-3.38,3.38v7a81.57,81.57,0,0,0,16.94,1.69A81.43,81.43,0,0,0,42,28.94v-7a3.38,3.38,0,0,0-3.38-3.38Z",
    transform: "translate(-8.13 -14.46)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBriefcase);
export default __webpack_public_path__ + "static/media/ic_briefcase.673affa97950cbe8be86cc96626a317a.svg";
export { ForwardRef as ReactComponent };